export const formatCurrency = (amount: number): string => {
  if (Math.abs(amount) >= 1_000_000) {
    return `$${(amount / 1_000_000).toFixed(2)} M`;
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatCurrencyCompact = (value: number): string => {
  return `$${(value / 1000).toFixed(0)}k`;
};

export const formatTooltipValue = (value: number): string => {
  return `$${value.toLocaleString()}`;
};
